import { requestHandlerFabric } from 'api/instance';
import { getKitApiPrefix } from 'common/constants';

/**
 * Kit-flow analytics events (§15). Property names match the analytics spec so
 * call sites + payloads exist now and reporting can be wired later. The BE
 * event endpoint may not exist yet, so failures are swallowed (fire-and-forget)
 * and we always log in dev.
 */
export type KitAnalyticsEvent =
  | 'assembly_confirm_viewed'
  | 'assembly_saved'
  | 'assembly_updated'
  | 'kit_created'
  | 'kit_line_added'
  | 'kit_line_qty_changed'
  | 'kit_limit_reached'
  | 'accessory_added'
  | 'catalog_searched'
  | 'pdf_generated'
  | 'session_reset';

export type KitAnalyticsProps = Record<string, unknown>;

const EVENT_PATH = '/kit-events';

export const track = (event: KitAnalyticsEvent, props: KitAnalyticsProps = {}): void => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.debug('[kitAnalytics]', event, props);
  }
  try {
    requestHandlerFabric()
      .post(`${getKitApiPrefix()}${EVENT_PATH}`, { event, props })
      .catch(() => {});
  } catch {
    // never let analytics break the flow
  }
};

export default track;
